import { dataFetcher } from 'core/services/requestHandler';   

const getPasses = async (data = {}, config = {}) => {
  return dataFetcher('passes/getPasses', data, {...config});
};

const getPassDetails = async (data = {}, config = {}) => {
  return dataFetcher('passes/getPassDetails', data, {...config});
};

const savePass = async (data = {}, config = {}) => {
  return dataFetcher('passes/savePass', data, {method: 'POST', ...config});
};

const deletePass = async (data = {}, config = {}) => {
  return dataFetcher('passes/deletePass', data, {...config});
};
// const getPassesByPropertyType = async (data = {}, config = {}) => {
//   return dataFetcher('passes/getPassesByPropertyType', data, {...config});
// };

const getPassesByProperty = async (data = {}, config = {}) => {
  return dataFetcher('passes/getPassesByProperty', data, {...config});
};

export { savePass, getPasses, getPassDetails, deletePass, getPassesByProperty };
